import { render, staticRenderFns } from "./Relations.vue?vue&type=template&id=2ea75aa4&scoped=true&"
import script from "./Relations.vue?vue&type=script&lang=js&"
export * from "./Relations.vue?vue&type=script&lang=js&"
import style0 from "./Relations.vue?vue&type=style&index=0&id=2ea75aa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea75aa4",
  null
  
)

export default component.exports